import { render, staticRenderFns } from "./PointSetting.vue?vue&type=template&id=0fc53b67&"
import script from "./PointSetting.vue?vue&type=script&lang=js&"
export * from "./PointSetting.vue?vue&type=script&lang=js&"
import style0 from "./PointSetting.vue?vue&type=style&index=0&id=0fc53b67&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports